define.alias("shared/components/shared/pinterest-business", "calendar/components/shared/pinterest-business");